// extracted by mini-css-extract-plugin
export default {"nftOffer":"iilSQ5_74gc6KX9PDjTy","nftOfferListContainer":"PHdceSUKQQ5F9xacw1XK","nftOfferList":"C7J7S9Gby7L7vXj2NGfn"};